import "./styles.less";

import React from "react";

const ROTATING_WORDS = ["Descubrí", "Invertí", "Publicá"];

// La primera palabra se repite al final para que el ciclo cierre sin salto: al pasar
// de la última a la primera el track ya está mostrando una copia idéntica.
const WORD_CYCLE = [...ROTATING_WORDS, ROTATING_WORDS[0]];

export const BannerPuntaDelEste = () => {
	return (
		<section className="banner-pde" aria-label="Proyectos destacados en el Este">
			<div className="banner-pde__content">
				<p className="banner-pde__eyebrow">
					<span className="banner-pde__rule" />
					Proyectos destacados
				</p>

				<h2 className="banner-pde__title">
					Proyectos en el Este:{" "}
					<span className="banner-pde__rotator">
						{/* El lector de pantalla recibe las tres palabras de una; el track
						    animado queda oculto para no leerlas repetidas. */}
						<span className="banner-pde__rotator-sr">{ROTATING_WORDS.join(", ")}</span>
						<span className="banner-pde__rotator-track" aria-hidden="true">
							{WORD_CYCLE.map((word, i) => (
								<span className="banner-pde__word" key={`${word}-${i}`}>
									{word}
								</span>
							))}
						</span>
					</span>
				</h2>

				<p className="banner-pde__subtitle">
					Conectamos propiedades extraordinarias con compradores de alto nivel
				</p>
			</div>
		</section>
	);
};
